import { ReactElement } from "react";
import { SvgIconProps } from "@mui/material/SvgIcon";
import {
    Announcement,
    AccountCircle,
    ContactPage as Contact,
    Construction,
    Event,
    MeetingRoom,
    ManageAccounts,
    Museum,
    People,
    PermMedia,
    ShoppingCart,
} from "@mui/icons-material";
import { AdminIconName } from "@/app/features/sites/admin/navigation/admin-navigation";

export interface IconByNameProps extends Omit<SvgIconProps, "color"> {
    name: AdminIconName | "Construction";
    color?: string;
}

const ICONS = {
    Announcement,
    Contact,
    Construction,
    Event,
    MeetingRoom,
    ManageAccounts,
    Museum,
    People,
    PermMedia,
    ShoppingCart,
    Account: AccountCircle,
} as const;

export default function IconByName({ name, color, ...props }: IconByNameProps): ReactElement {
    // Keep navigation resilient if a stale or invalid icon name reaches the UI.
    // This also protects the render path from React's "element type is invalid"
    // error when content and the icon registry drift out of sync.
    const IconComponent = ICONS[name] ?? Construction;

    return (
        <IconComponent
            style={{
                color: color
            }}
            {...props}
        />
    );
}
